// extracted by mini-css-extract-plugin
export default {"select-custom-dropdown":"Select_select-custom-dropdown__QuG9E","select-custom-div":"Select_select-custom-div__vWaNu","select-custom-label":"Select_select-custom-label__85R+G"};